// extracted by mini-css-extract-plugin
export var actionButton = "_xa-2";
export var card = "_xa-0";
export var errorCard = "_xa-1";